import { previewPicture } from '@/utils';
import Markdown from '@/components/markdown';
import Ocr, { IOCR } from './ocr';
import './index.scss';
import classNames from 'classnames';

interface IBasic {
    type: 'basic';
    content: string;
    createdAt?: string;
    pictures?: string[];
}

interface IOcrQuestioner extends IOCR {
    type: 'ocr';
}

interface IQaPairQuestioner {
    recordId: string;
    type: 'qaPairQuestioner';
    content: string;
    isFlash?: boolean;
}

export type IQuestioner = {
    role: 'questioner';
} & (IBasic | IOcrQuestioner | IQaPairQuestioner);

const Questioner = (data: IQuestioner) => {
    switch (data.type) {
        case 'basic':
            return (
                <>
                    {data.createdAt && <div className="qa-records-create-date">{data.createdAt}</div>}
                    <div className="questioner-container">
                        <div className="questioner">
                            <div className="questioner__discribe">
                                <Markdown content={data.content} />
                            </div>
                            <div className="questioner__pictures">
                                {(data.pictures || []).map((url, index) => {
                                    return (
                                        <img
                                            className="questioner__picture"
                                            // eslint-disable-next-line react/no-array-index-key
                                            key={url + index}
                                            src={url}
                                            onClick={() => previewPicture(url)}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </>
            );
        case 'ocr':
            return <Ocr {...data} />;
        case 'qaPairQuestioner':
            return (
                <div className={classNames('questioner-container', data.isFlash && 'questioner-container--flash')}>
                    <div className="questioner">
                        <div className="questioner__discribe">
                            <Markdown content={data.content} />
                        </div>
                    </div>
                </div>
            );
        default:
            return null;
    }
};

export default Questioner;
